import API from "../config/api.js";

export const PurchaseOrderService = {

  getBranches() {
    return API.get("/api/inventory/branches");
  },

  getSuppliers() {
    return API.get("/api/inventory/suppliers");
  },

  getRequisitionProducts(requisitionId) {
    return API.get(`/api/requisitions/requisitionproducts/${requisitionId}`);
  },

  getRequisitions(searchTerm = "") {
    return API.get(`/api/requisitions/getIds`, {
      params: {
        search: searchTerm,
      },
    });
  },

  async createPurchaseOrder(formData) {
    try {
      const response = await API.post("/api/purchaseorder/create", formData);
      return response.data;
    } catch (error) {
      console.error("Error creating purchase order:", error);
      throw error;
    }
  },

  getPurchaseOrders(search, page = 1) {
    return API.get(`/api/purchaseorder/list/se=${search}`, { params: { page: page } });
  },


  async getPurchaseOrderDetails(uuid) {
    try {
      const response = await API.get(`/api/purchaseorder/info/${uuid}`);
      return response.data.data; // Return the specific purchase order details
    } catch (error) {
      console.error("Error fetching purchase order details:", error);
      throw error;
    }
  },

  async getItemsByPoNumber(po_number) {
    console.log("po_number in service", po_number);
    try {
      const response = await API.get(`/api/purchaseorder/info/items/${po_number}`);
      console.log("data : ", response.data.data);
      return response.data.data; // Return items for the given PO number

    } catch (error) {
      console.error("Error fetching items by PO number:", error);
      throw error;
    }
  },

  async updatePurchaseOrder(uuid, formData) {
    try {
      const response = await API.patch(`/api/purchaseorder/update/${uuid}`, formData);
      console.log("Purchase Order updated successfully", response.data);
      return response.data; // Optionally return the updated PO data
    } catch (error) {
      console.error("Error Updating the PO", error);
      throw error;
    }
  },

  async dropMember(uuid) {
    try {
      const response = await API.delete(`api/purchaseorder/delete/${uuid}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting the purchase order:", error);
      throw error;
    }
  }

}
